export const CONNECTIONS_ENDPOINT = '/connections';

export const ConnectionCacheKeys = Object.freeze({
  GetConnectionTypes: 'getConnectionTypes',
  GetLinkedAccount: 'getLinkedAccount',
});

export const FivetranConnectionCacheKeys = Object.freeze({
  GetConnections: 'getFivetranConnections',
  GetConnectionTypes: 'getFivetranConnectionTypes',
});
